module.exports = __webpack_public_path__ + "assets/eksmo.ru.cb304cc95b2509e2cc07b65a130a76c89a0609d70071c92c76370539fce3837d.jpg";